export default [
  'scrapper-ai',
  'scrapper',
  'bus_stop_outline',
  'directions_bus_outline',
  'directions_subway_outline',
  'lab_research_outline',
  'local_hospital_outline',
  'local_mall_outline',
  'local_pharmacy_outline',
  'medical_services_outline',
  'nature_people_outline',
  'oncology_outline',
  'park_outline',
  'shopping_basket_outline',
  'subway_station_outline',
  'apparel_outline',
  'bed_outline',
  'device_tablet',
  'device_phone',
  'os_android',
  'os_linux',
  'browser_opera',
  'os_windows',
  'browser_yandex',
  'browser_vivaldi',
  'browser_ie',
  'browser_edge',
  'browser_safari',
  'browser_firefox',
  'browser_chrome',
  'os_macos',
  'os_ios',
  'zoox_icon',
  'partly_cloudy_day',
  'locked_profile',
  'api_python',
  'api_lambda',
  'api_rest',
  'abc',
  'cable',
  'query_stats',
  'rename',
  'upload',
  'book_2',
  'bar_chart_4_bars',
  'psychology_alt',
  'push',
  'coin',
  'whatsapp',
  'zooxai_icon',
  'steppers',
  'edit_calendar',
  'call_lock',
  'call_ok',
  'mail_lock',
  'data_object',
  'summarize',
  'assured_workload',
  'code_blocks',
  'ai_img',
  'write_magic',
  'sticky_note',
  'ai_text',
  'join_right',
  'join_inner',
  'join_left',
  'join',
  'cycle',
  'switch_access',
  'arrow_split',
  'step',
  'cloud_sync',
  'person_finder_bigdata',
  'registration_partner_registration',
  'schedule_calendar_campaign',
  'registrations_type_of_company',
  'registrations_group',
  'registrations_company',
  'registrations_roaming',
  'receitafederal',
  'article1',
  'social_tiktok',
  'social_twitterx',
  'social_youtube',
  'exclamation',
  'gavel1',
  'straighten1',
  'simples_nacional',
  'quick_reference_all',
  'calendar_clock',
  'hourglass',
  'person_search1',
  'account_tree1',
  'dns1',
  'floor',
  'director',
  'creditcard_cvv',
  'analytics_error_cron',
  'analytics_error_report',
  'analytics_wifi_send',
  'hotspot_registrations_manage_mikrotik',
  'large_scale_data_load',
  'partner_registration_system_resources',
  'person_finder_bigdata1',
  'registration_region_city',
  'registration_region_state',
  'registrations_user_role',
  'registrations__manage_mikrotik_1',
  'report_error_analytics',
  'double_approval',
  'patient',
  'registration_partner_additional_data',
  'analytics_login_metrics',
  'email_marketing_campaign',
  'hospitality_rules_integration',
  'portal_configurations',
  'registration_partner_parameters',
  'registration_registered',
  'registration_sending_access_point',
  'registrations__administrative_portal_user',
  'registrations_access_blocked_mac',
  'registrations_access_blocked_person',
  'registrations_block_user',
  'integration_hospital',
  'nps_analytics',
  'zmx_building',
  'zmx_campus',
  'zmx_floor',
  'zmx_flow_map',
  'zmx_heat_map',
  'zmx_scatter_map',
  'new_charged',
  'new_charged_1',
  'plans_register',
  'registrations__internet_provider',
  'registrations__mac_search',
  'registrations__terms_use',
  'registrations_access_point',
  'registrations_additional_data',
  'registrations_card_add_dashboard',
  'registrations_internet_link',
  'registrations_label',
  'registrations_label_1',
  'registrations_monitoring',
  'registrations_network_port',
  'registrations_parameter',
  'registrations_privacy_policy',
  'registrations_router',
  'rules_integration__hospitality',
  'annual_calendar_campaign',
  'canceled_registrations_campaign',
  'hospitality_integration_companies',
  'mapa_analytics',
  'media_active_campaigns_campaign',
  'media_campaign',
  'midias_analytics',
  'monitor_analytics',
  'monitor_cisco_analytics',
  'newsletter_analytics',
  'nps_campaign',
  'online_analytics',
  'online_service',
  'partners_analytics',
  'report_consumption_analytics',
  'search_active_campaigns_campaign',
  'sms_campaign',
  'survey_campaign',
  'visitor_analytics',
  'zendesk_analytics',
  'access_report_hospitality',
  'apartment_register_hospitality',
  'audit_analytics',
  'connections_analytics',
  'control_panel_bigdata',
  'email_marketing_analytics',
  'email_welcome_analytics',
  'event_register_apartment',
  'eventhall_register_hospitality',
  'flag_hospitality',
  'guest_hospitality',
  'hospitality_integration_myintegration',
  'hotspot_analytics',
  'hotspot_connections_analytics',
  'hotspot_rating_analytics',
  'maintenance__analytics__hospitality',
  'mosaic_hospitality',
  'occupation_manual_analytics',
  'openpay_charged',
  'parameter_hospitality',
  'processed_tickets_hospitality',
  'processing_tickets_hospitality',
  'register_patient__hospital',
  'reserve__analytics__hospitality',
  'room_service__analytics__hospitality_1',
  'rules_registration_integration__hospitality',
  'sms_analytics',
  'ticket_report_hospitality',
  'token_sms_analytics',
  'user_ranking_analytics',
  'wifi_room_analytics',
  'add_alert',
  'album',
  'av_timer',
  'closed_caption',
  'equalizer',
  'explicit',
  'fast_forward',
  'fast_rewind',
  'games',
  'hearing',
  'high_quality',
  'loop',
  'mic_none',
  'mic_off',
  'movie',
  'library_books',
  'library_music',
  'new_releases',
  'not_interested',
  'pause',
  'pause_circle_filled',
  'pause_circle_outline',
  'play_arrow',
  'play_circle_filled',
  'play_circle_outline',
  'queue_music',
  'radio',
  'recent_actors',
  'repeat',
  'repeat_one',
  'replay1',
  'shuffle',
  'skip_next',
  'skip_previous',
  'snooze',
  'stop',
  'subtitles',
  'surround_sound',
  'video_library',
  'videocam',
  'videocam_off',
  'volume_down',
  'volume_mute',
  'volume_off',
  'volume_up',
  'web',
  'hd',
  'sort_by_alpha',
  'airplay',
  'forward_101',
  'forward_301',
  'forward_51',
  'replay_101',
  'replay_301',
  'replay_51',
  'fiber_dvr',
  'fiber_new',
  'playlist_play',
  'art_track',
  'fiber_manual_record',
  'fiber_smart_record',
  'music_video',
  'subscriptions',
  'queue_play_next',
  'remove_from_queue',
  'slow_motion_video',
  'web_asset',
  'fiber_pin1',
  'branding_watermark',
  'call_to_action',
  'featured_play_list',
  'featured_video',
  'note',
  'video_call',
  'video_label',
  '4k',
  'missed_video_call',
  'control_camera',
  'business',
  'call',
  'call_end',
  'call_made',
  'call_merge',
  'call_missed',
  'call_received',
  'call_split',
  'chat',
  'clear_all',
  'comment',
  'contacts',
  'dialer_sip',
  'dialpad',
  'email',
  'forum',
  'import_export',
  'invert_colors_off',
  'live_help',
  'location_off',
  'location_on',
  'message',
  'chat_bubble',
  'chat_bubble_outline',
  'no_sim',
  'phone',
  'portable_wifi_off',
  'contact_phone',
  'contact_mail',
  'ring_volume',
  'speaker_phone',
  'stay_current_landscape',
  'stay_current_portrait',
  'swap_calls',
  'textsms',
  'voicemail',
  'vpn_key',
  'phonelink_erase',
  'phonelink_lock',
  'phonelink_ring',
  'phonelink_setup',
  'present_to_all',
  'import_contacts',
  'mail_outline',
  'screen_share',
  'stop_screen_share',
  'call_missed_outgoing',
  'rss_feed',
  'alternate_email',
  'mobile_screen_share',
  'cancel_presentation',
  'pause_presentation',
  'unsubscribe',
  'cell_wifi',
  'sentiment_satisfied_alt',
  'list_alt',
  'domain_disabled',
  'lightbulb',
  'archive',
  'backspace',
  'block',
  'clear',
  'content_copy',
  'content_cut',
  'content_paste',
  'create',
  'drafts',
  'filter_list',
  'flag',
  'forward',
  'gesture',
  'inbox',
  'link',
  'redo',
  'remove',
  'remove_circle',
  'remove_circle_outline',
  'reply',
  'reply_all',
  'report',
  'save',
  'select_all',
  'send',
  'sort',
  'text_format',
  'undo',
  'font_download',
  'move_to_inbox',
  'unarchive',
  'next_week',
  'weekend',
  'delete_sweep',
  'low_priority',
  'outlined_flag',
  'link_off',
  'report_off',
  'save_alt',
  'ballot',
  'file_copy1',
  'how_to_reg',
  'how_to_vote',
  'waves',
  'where_to_vote',
  'add_link',
  'inventory',
  'access_alarm',
  'access_alarms',
  'access_time',
  'airplanemode_off',
  'airplanemode_on',
  'battery_alert',
  'battery_charging_full',
  'battery_full',
  'battery_unknown',
  'bluetooth',
  'bluetooth_connected',
  'bluetooth_disabled',
  'bluetooth_searching',
  'brightness_auto',
  'brightness_high',
  'brightness_low',
  'brightness_medium',
  'data_usage',
  'developer_mode',
  'devices',
  'dvr',
  'gps_fixed',
  'gps_not_fixed',
  'gps_off',
  'graphic_eq',
  'network_cell',
  'network_wifi',
  'nfc',
  'now_wallpaper',
  'now_widgets',
  'screen_lock_landscape',
  'screen_lock_portrait',
  'screen_lock_rotation',
  'screen_rotation',
  'sd_storage',
  'settings_system_daydream',
  'signal_cellular_4_bar',
  'signal_cellular_connected_no_internet_4_bar',
  'signal_cellular_null',
  'signal_cellular_off',
  'signal_wifi_4_bar',
  'signal_wifi_4_bar_lock',
  'signal_wifi_off',
  'storage',
  'usb',
  'wifi_lock',
  'wifi_tethering',
  'device_thermostat',
  'mobile_friendly',
  'mobile_off',
  'signal_cellular_alt',
  'attach_file',
  'attach_money',
  'border_all',
  'border_bottom',
  'border_clear',
  'border_color',
  'border_horizontal',
  'border_inner',
  'border_left',
  'border_outer',
  'border_right',
  'border_style',
  'border_top',
  'border_vertical',
  'format_align_center',
  'format_align_justify',
  'format_align_left',
  'format_align_right',
  'format_bold',
  'format_clear',
  'format_color_fill',
  'format_color_reset',
  'format_color_text',
  'format_indent_decrease',
  'format_indent_increase',
  'format_italic',
  'format_line_spacing',
  'format_list_bulleted',
  'format_list_numbered',
  'format_paint',
  'format_quote',
  'format_size',
  'format_strikethrough',
  'format_textdirection_l_to_r',
  'format_textdirection_r_to_l',
  'format_underlined',
  'insert_chart',
  'insert_comment',
  'insert_drive_file',
  'insert_emoticon',
  'insert_invitation',
  'insert_photo',
  'mode_comment',
  'publish',
  'space_bar',
  'strikethrough_s',
  'vertical_align_bottom',
  'vertical_align_center',
  'vertical_align_top',
  'wrap_text',
  'money_off',
  'drag_handle',
  'format_shapes1',
  'highlight',
  'linear_scale',
  'short_text',
  'text_fields',
  'monetization_on',
  'title',
  'table_chart',
  'format_list_numbered_rtl',
  'scatter_plot',
  'score',
  'insert_chart_outlined',
  'bar_chart',
  'notes',
  'attachment',
  'cloud',
  'cloud_circle',
  'cloud_done',
  'cloud_download',
  'cloud_off',
  'cloud_queue',
  'cloud_upload',
  'file_download',
  'file_upload',
  'folder',
  'folder_open',
  'folder_shared',
  'create_new_folder',
  'cast',
  'cast_connected',
  'computer',
  'desktop_mac',
  'desktop_windows',
  'developer_board',
  'dock',
  'headset',
  'headset_mic',
  'keyboard',
  'keyboard_arrow_down',
  'keyboard_arrow_left',
  'keyboard_arrow_right',
  'keyboard_arrow_up',
  'keyboard_backspace',
  'keyboard_capslock',
  'keyboard_hide',
  'keyboard_return',
  'keyboard_tab',
  'keyboard_voice',
  'laptop_chromebook',
  'laptop_mac',
  'laptop_windows',
  'memory',
  'mouse',
  'phone_android',
  'phone_iphone',
  'phonelink_off',
  'router',
  'scanner',
  'security',
  'sim_card',
  'speaker',
  'speaker_group',
  'tablet',
  'tablet_android',
  'tablet_mac',
  'toys',
  'tv',
  'watch',
  'device_hub',
  'power_input',
  'devices_other',
  'videogame_asset',
  'device_unknown',
  'headset_off',
  'adjust',
  'assistant',
  'audiotrack',
  'blur_circular',
  'blur_linear',
  'blur_off',
  'blur_on',
  'brightness_1',
  'brightness_2',
  'brightness_3',
  'brightness_4',
  'broken_image',
  'brush',
  'camera',
  'camera_alt',
  'camera_front',
  'camera_rear',
  'camera_roll',
  'center_focus_strong',
  'center_focus_weak',
  'collections',
  'color_lens',
  'colorize',
  'compare',
  'control_point_duplicate',
  'crop_16_9',
  'crop_3_2',
  'crop',
  'crop_5_4',
  'crop_7_5',
  'crop_din',
  'crop_free',
  'crop_original',
  'crop_portrait',
  'crop_square',
  'dehaze',
  'details',
  'exposure',
  'exposure_neg_1',
  'exposure_neg_2',
  'exposure_zero',
  'filter_1',
  'filter_2',
  'filter_3',
  'filter',
  'filter_4',
  'filter_5',
  'filter_6',
  'filter_7',
  'filter_8',
  'filter_9',
  'filter_b_and_w',
  'filter_center_focus',
  'filter_drama',
  'filter_frames',
  'filter_hdr',
  'filter_none',
  'filter_tilt_shift',
  'filter_vintage',
  'flare',
  'flash_auto1',
  'flash_off',
  'flash_on',
  'flip',
  'gradient',
  'grain',
  'grid_off',
  'grid_on',
  'hdr_off',
  'hdr_on',
  'hdr_strong',
  'hdr_weak',
  'healing',
  'image_aspect_ratio',
  'iso',
  'leak_remove',
  'lens',
  'looks_3',
  'looks',
  'looks_4',
  'looks_5',
  'looks_6',
  'looks_one',
  'looks_two',
  'loupe',
  'monochrome_photos',
  'music_note',
  'nature',
  'nature_people',
  'navigate_before',
  'navigate_next',
  'panorama',
  'panorama_fisheye',
  'panorama_horizontal',
  'panorama_vertical',
  'panorama_wide_angle',
  'photo_album',
  'picture_as_pdf',
  'portrait',
  'remove_red_eye',
  'rotate_90_degrees_ccw',
  'rotate_left',
  'rotate_right',
  'slideshow',
  'straighten',
  'style',
  'switch_camera',
  'switch_video',
  'texture',
  'timelapse',
  'timer_10',
  'timer_3',
  'timer',
  'timer_off',
  'tonality',
  'transform',
  'tune',
  'view_comfy',
  'view_compact',
  'wb_auto',
  'wb_cloudy',
  'wb_incandescent',
  'wb_sunny',
  'collections_bookmark',
  'photo_size_select_actual',
  'photo_size_select_large',
  'photo_size_select_small',
  'vignette',
  'wb_iridescent',
  'crop_rotate',
  'linked_camera',
  'movie_filter',
  'photo_filter',
  'burst_mode',
  'shutter_speed',
  'image_search',
  'music_off',
  'beenhere',
  'directions_train',
  'hotel',
  'layers',
  'layers_clear',
  'local_atm',
  'local_attraction',
  'local_bar',
  'local_cafe',
  'local_car_wash',
  'local_convenience_store',
  'local_drink',
  'local_florist',
  'local_gas_station',
  'local_grocery_store',
  'local_hospital',
  'local_laundry_service',
  'local_library',
  'local_mall',
  'local_movies',
  'local_offer',
  'local_parking',
  'local_pharmacy',
  'local_pizza',
  'local_printshop',
  'local_restaurant',
  'local_shipping',
  'local_taxi',
  'location_history',
  'map',
  'navigation',
  'pin_drop',
  'rate_review',
  'satellite',
  'store_mall_directory',
  'traffic',
  'edit_location',
  'near_me',
  'person_pin_circle',
  'zoom_out_map',
  'restaurant',
  'ev_station',
  'streetview',
  'subway',
  'train',
  'tram',
  'transfer_within_a_station',
  'atm',
  'category',
  'not_listed_location',
  'departure_board',
  '360',
  'edit_attributes',
  'transit_enterexit',
  'fastfood',
  'trip_origin',
  'compass_calibration',
  'money',
  'apps',
  'arrow_back',
  'arrow_drop_down',
  'arrow_drop_down_circle',
  'arrow_drop_up',
  'arrow_forward',
  'cancel',
  'check',
  'expand_less',
  'expand_more',
  'fullscreen',
  'fullscreen_exit',
  'menu',
  'keyboard_control',
  'more_vert',
  'refresh',
  'unfold_less',
  'unfold_more',
  'arrow_upward',
  'subdirectory_arrow_left',
  'subdirectory_arrow_right',
  'arrow_downward',
  'first_page',
  'last_page',
  'arrow_left',
  'arrow_right',
  'arrow_back_ios',
  'arrow_forward_ios',
  'adb',
  'disc_full',
  'do_not_disturb_alt',
  'drive_eta',
  'event_available',
  'event_busy',
  'event_note',
  'folder_special',
  'mms',
  'more',
  'network_locked',
  'sms_failed',
  'sync_disabled',
  'sync_problem',
  'system_update',
  'tap_and_play',
  'vibration',
  'voice_chat',
  'vpn_lock',
  'airline_seat_flat',
  'airline_seat_flat_angled',
  'airline_seat_individual_suite',
  'airline_seat_legroom_extra',
  'airline_seat_legroom_normal',
  'airline_seat_legroom_reduced',
  'airline_seat_recline_extra',
  'airline_seat_recline_normal',
  'confirmation_number',
  'live_tv',
  'ondemand_video',
  'personal_video',
  'power',
  'wc',
  'wifi',
  'enhanced_encryption',
  'network_check',
  'no_encryption',
  'rv_hookup',
  'do_not_disturb_off',
  'priority_high',
  'power_off',
  'tv_off',
  'wifi_off',
  'phone_callback',
  'pie_chart',
  'pie_chart_outlined',
  'bubble_chart',
  'multiline_chart',
  'show_chart',
  'cake',
  'group',
  'location_city',
  'mood_bad',
  'pages',
  'party_mode',
  'people_outline',
  'person',
  'person_outline',
  'public',
  'school',
  'share',
  'whatshot',
  'sentiment_dissatisfied',
  'sentiment_neutral',
  'sentiment_satisfied',
  'sentiment_very_dissatisfied',
  'sentiment_very_satisfied',
  'thumb_down_alt',
  'thumb_up_alt',
  'check_box',
  'check_box_outline_blank',
  'radio_button_on',
  'star',
  'star_half',
  'star_outline',
  '3d_rotation',
  'accessibility',
  'account_balance',
  'account_balance_wallet',
  'account_box',
  'account_circle1',
  'alarm_off',
  'alarm_on',
  'android',
  'announcement',
  'aspect_ratio',
  'assignment',
  'assignment_ind',
  'assignment_late',
  'assignment_return',
  'assignment_returned',
  'assignment_turned_in',
  'autorenew',
  'book',
  'bookmark',
  'bookmark_outline',
  'build',
  'cached',
  'change_history',
  'check_circle',
  'chrome_reader_mode',
  'code',
  'credit_card',
  'dashboard',
  'delete',
  'dns',
  'done',
  'done_all',
  'exit_to_app',
  'explore',
  'extension',
  'face',
  'favorite',
  'favorite_outline',
  'find_in_page',
  'find_replace',
  'flip_to_back',
  'flip_to_front',
  'group_work',
  'help',
  'highlight_remove',
  'history',
  'home',
  'hourglass_empty',
  'hourglass_full',
  'https',
  'info',
  'info_outline',
  'input',
  'invert_colors_on',
  'label',
  'label_outline',
  'language',
  'launch',
  'list',
  'lock_open',
  'lock_outline',
  'loyalty',
  'markunread_mailbox',
  'open_in_browser',
  'open_with',
  'pageview',
  'perm_camera_mic',
  'perm_contact_calendar',
  'perm_data_setting',
  'perm_device_information',
  'perm_media',
  'perm_phone_msg',
  'perm_scan_wifi',
  'picture_in_picture',
  'polymer',
  'power_settings_new',
  'receipt',
  'redeem',
  'search',
  'settings',
  'settings_applications',
  'settings_backup_restore',
  'settings_bluetooth',
  'settings_cell',
  'settings_display',
  'settings_ethernet',
  'settings_input_antenna',
  'settings_input_component',
  'settings_input_hdmi',
  'settings_input_svideo',
  'settings_overscan',
  'settings_phone',
  'settings_power',
  'settings_remote',
  'settings_voice',
  'shop',
  'shop_two',
  'shopping_basket',
  'speaker_notes',
  'spellcheck',
  'stars',
  'subject',
  'supervisor_account',
  'swap_horiz',
  'swap_vert',
  'swap_vertical_circle',
  'system_update_tv',
  'tab',
  'tab_unselected',
  'thumb_down',
  'thumb_up',
  'thumbs_up_down',
  'toc',
  'today',
  'toll',
  'track_changes',
  'translate',
  'trending_down',
  'trending_neutral',
  'trending_up',
  'verified_user',
  'view_agenda',
  'view_array',
  'view_carousel',
  'view_column',
  'view_day',
  'view_headline',
  'view_list',
  'view_module',
  'view_quilt',
  'view_stream',
  'view_week',
  'visibility_off',
  'card_membership',
  'card_travel',
  'work',
  'youtube_searched_for',
  'eject',
  'camera_enhance',
  'help_outline',
  'reorder',
  'zoom_in',
  'zoom_out',
  'http',
  'event_seat',
  'flight_land',
  'flight_takeoff',
  'play_for_work',
  'gif',
  'indeterminate_check_box',
  'offline_pin',
  'all_out',
  'copyright',
  'fingerprint',
  'gavel',
  'lightbulb_outline',
  'picture_in_picture_alt',
  'important_devices',
  'touch_app',
  'accessible',
  'compare_arrows',
  'date_range',
  'donut_large',
  'donut_small',
  'line_style',
  'line_weight',
  'motorcycle',
  'opacity',
  'pets',
  'pregnant_woman',
  'record_voice_over',
  'rounded_corner',
  'rowing',
  'timeline',
  'update',
  'watch_later',
  'pan_tool',
  'euro_symbol',
  'g_translate',
  'remove_shopping_cart',
  'restore_page',
  'speaker_notes_off',
  'delete_forever',
  'accessibility_new',
  'check_circle_outline',
  'delete_outline',
  'done_outline',
  'maximize',
  'minimize',
  'offline_bolt',
  'swap_horizontal_circle',
  'accessible_forward',
  'calendar_today',
  'calendar_view_day',
  'label_important',
  'restore_from_trash',
  'supervised_user_circle',
  'text_rotate_up',
  'text_rotate_vertical',
  'text_rotation_angledown',
  'text_rotation_angleup',
  'text_rotation_down',
  'text_rotation_none',
  'commute',
  'arrow_right_alt',
  'work_off',
  'work_outline',
  'drag_indicator',
  'horizontal_split',
  'label_important_outline',
  'vertical_split',
  'voice_over_off',
  'segment',
  'contact_support',
  'compress',
  'filter_list_alt',
  'expand',
  'edit_off',
  '10k',
  '10mp',
  '11mp',
  '12mp',
  '13mp',
  '14mp',
  '15mp',
  '16mp',
  '17mp',
  '18mp',
  '19mp',
  '1k',
  '1k_plus',
  '20mp',
  '21mp',
  '22mp',
  '23mp',
  '24mp',
  '2k',
  '2k_plus',
  '2mp',
  '3k',
  '3k_plus',
  '3mp',
  '4k_plus',
  '4mp',
  '5k',
  '5k_plus',
  '5mp',
  '6k',
  '6k_plus',
  '6mp',
  '7k',
  '7k_plus',
  '7mp',
  '8k',
  '8k_plus',
  '8mp',
  '9k',
  '9k_plus',
  '9mp',
  'account_tree',
  'add_chart',
  'add_ic_call',
  'add_moderator',
  'all_inbox',
  'approval',
  'assistant_direction',
  'assistant_navigation',
  'bookmarks',
  'bus_alert',
  'cases',
  'circle_notifications',
  'closed_caption_off',
  'connected_tv',
  'dangerous',
  'dashboard_customize',
  'desktop_access_disabled',
  'drive_file_move_outline',
  'drive_file_rename_outline',
  'drive_folder_upload',
  'duo',
  'explore_off',
  'file_download_done',
  'rtt',
  'grid_view',
  'hail',
  'home_filled',
  'imagesearch_roller',
  'label_off',
  'library_add_check',
  'logout',
  'margin',
  'mark_as_unread',
  'menu_open',
  'mp',
  'offline_share',
  'padding',
  'panorama_photosphere',
  'panorama_photosphere_select',
  'phone_disabled',
  'phone_enabled',
  'pivot_table_chart',
  'print_disabled',
  'railway_alert',
  'recommend',
  'remove_done',
  'remove_moderator',
  'repeat_on',
  'repeat_one_on',
  'replay_circle_filled',
  'reset_tv',
  'sd',
  'shield',
  'shuffle_on',
  'speed',
  'stacked_bar_chart',
  'stream',
  'swipe',
  'switch_account',
  'tag',
  'thumb_down_off_alt',
  'thumb_up_off_alt',
  'toggle_off',
  'toggle_on',
  'two_wheeler',
  'upload_file',
  'view_in_ar',
  'waterfall_chart',
  'wb_shade',
  'wb_twighlight',
  'home_work',
  'schedule_send',
  'bolt',
  'send_and_archive',
  'workspaces_filled',
  'file_present',
  'workspaces_outline',
  'fit_screen',
  'saved_search',
  'storefront',
  'amp_stories',
  'dynamic_feed',
  'euro',
  'height',
  'policy',
  'sync_alt',
  'menu_book',
  'emoji_flags',
  'emoji_food_beverage',
  'emoji_nature',
  'emoji_people',
  'emoji_symbols',
  'emoji_transportation',
  'post_add',
  'people_alt',
  'emoji_emotions',
  'emoji_events',
  'emoji_objects',
  'sports_basketball',
  'sports_cricket',
  'sports_esports',
  'sports_football',
  'sports_golf',
  'sports_hockey',
  'sports_mma',
  'sports_motorsports',
  'sports_rugby',
  'sports_soccer',
  'sports',
  'sports_volleyball',
  'sports_tennis',
  'sports_handball',
  'sports_kabaddi',
  'eco',
  'museum',
  'flip_camera_android',
  'flip_camera_ios',
  'cancel_schedule_send',
  'apartment',
  'bathtub',
  'deck',
  'fireplace',
  'house',
  'king_bed',
  'nights_stay',
  'outdoor_grill',
  'single_bed',
  'square_foot',
  'double_arrow',
  'sports_baseball',
  'attractions',
  'bakery_dining',
  'breakfast_dining',
  'car_rental',
  'car_repair',
  'dinner_dining',
  'dry_cleaning',
  'hardware',
  'liquor',
  'lunch_dining',
  'nightlife',
  'park',
  'ramen_dining',
  'celebration',
  'theater_comedy',
  'badge',
  'festival',
  'icecream',
  'volunteer_activism',
  'contactless',
  'delivery_dining',
  'brunch_dining',
  'takeout_dining',
  'ac_unit',
  'airport_shuttle',
  'all_inclusive',
  'beach_access',
  'business_center',
  'casino',
  'child_care',
  'child_friendly',
  'fitness_center',
  'golf_course',
  'hot_tub',
  'kitchen',
  'pool',
  'room_service',
  'smoke_free',
  'smoking_rooms',
  'spa',
  'no_meeting_room',
  'meeting_room',
  'goat',
  '5g',
  'ad_units',
  'add_business',
  'add_location_alt',
  'add_road',
  'add_to_drive',
  'addchart',
  'admin_panel_settings',
  'agriculture',
  'alt_route',
  'analytics',
  'anchor',
  'animation',
  'api',
  'app_blocking',
  'app_registration',
  'app_settings_alt',
  'architecture',
  'arrow_circle_down',
  'arrow_circle_up',
  'article',
  'attach_email',
  'auto_awesome',
  'auto_awesome_mosaic',
  'auto_awesome_motion',
  'auto_delete',
  'auto_fix_high',
  'auto_fix_normal',
  'auto_fix_off',
  'auto_stories',
  'baby_changing_station',
  'backpack',
  'backup_table',
  'batch_prediction',
  'bedtime',
  'bento',
  'bike_scooter',
  'biotech',
  'block_flipped',
  'browser_not_supported',
  'build_circle',
  'calculate',
  'campaign',
  'carpenter',
  'cast_for_education',
  'charging_station',
  'checkroom',
  'circle',
  'cleaning_services',
  'close_fullscreen',
  'closed_caption_disabled',
  'comment_bank',
  'construction',
  'corporate_fare',
  'countertops',
  'design_services',
  'directions_off',
  'dirty_lens',
  'do_not_step',
  'do_not_touch',
  'domain_verification',
  'drive_file_move',
  'dry',
  'dynamic_form',
  'east',
  'edit_road',
  'electric_bike',
  'electric_car',
  'electric_moped',
  'electric_rickshaw',
  'electric_scooter',
  'electrical_services',
  'elevator',
  'engineering',
  'escalator',
  'escalator_warning',
  'face_retouching_natural',
  'fact_check',
  'family_restroom',
  'fence',
  'filter_alt',
  'fire_extinguisher',
  'flaky',
  'food_bank',
  'forward_to_inbox',
  'foundation',
  'grading',
  'grass',
  'handyman',
  'hdr_enhanced_select',
  'hearing_disabled',
  'help_center',
  'highlight_alt',
  'history_edu',
  'history_toggle_off',
  'home_repair_service',
  'horizontal_rule',
  'hourglass_bottom',
  'hourglass_disabled',
  'hourglass_top',
  'house_siding',
  'hvac',
  'image_not_supported',
  'insights',
  'integration_instructions',
  'ios_share',
  'legend_toggle',
  'local_fire_department',
  'local_police',
  'location_pin',
  'lock_clock',
  'login',
  'maps_ugc',
  'mark_chat_read',
  'mark_chat_unread',
  'mark_email_read',
  'mark_email_unread',
  'mediation',
  'medical_services',
  'mic_external_off',
  'mic_external_on',
  'microwave',
  'military_tech',
  'miscellaneous_services',
  'model_training',
  'monitor',
  'moped',
  'more_time',
  'motion_photos_off',
  'motion_photos_on',
  'motion_photos_paused',
  'multiple_stop',
  'nat',
  'near_me_disabled',
  'next_plan',
  'night_shelter',
  'nightlight_round',
  'no_cell',
  'no_drinks',
  'no_flash',
  'no_food',
  'no_meals',
  'no_photography',
  'no_stroller',
  'no_transfer',
  'north',
  'north_east',
  'north_west',
  'not_accessible',
  'not_started',
  'online_prediction',
  'open_in_full',
  'outbox',
  'outgoing_mail',
  'outlet',
  'panorama_horizontal_select',
  'panorama_vertical_select',
  'panorama_wide_angle_select',
  'payments',
  'pedal_bike',
  'pending',
  'pending_actions',
  'person_add_alt',
  'person_add_alt_1',
  'person_remove',
  'person_search',
  'pest_control',
  'pest_control_rodent',
  'photo_camera_back',
  'photo_camera_front',
  'plagiarism',
  'play_disabled',
  'plumbing',
  'point_of_sale',
  'preview',
  'privacy_tip',
  'psychology',
  'public_off',
  'push_pin',
  'qr_code',
  'qr_code_scanner',
  'quickreply',
  'read_more',
  'receipt_long',
  'request_quote',
  'rice_bowl',
  'roofing',
  'room_preferences',
  'rule',
  'rule_folder',
  'run_circle',
  'science',
  'screen_search_desktop',
  'search_off',
  'self_improvement',
  'sensor_door',
  'sensor_window',
  'set_meal',
  'shopping_bag',
  'signal_cellular_0_bar',
  'signal_wifi_0_bar',
  'smart_button',
  'snippet_folder',
  'soap',
  'source',
  'south',
  'south_east',
  'south_west',
  'sports_bar',
  'stairs',
  'star_outline1',
  'star_rate',
  'sticky_note_2',
  'stop_circle',
  'stroller',
  'subscript',
  'subtitles_off',
  'superscript',
  'support',
  'support_agent',
  'switch_left',
  'switch_right',
  'table_rows',
  'table_view',
  'tapas',
  'taxi_alert',
  'text_snippet',
  'tour',
  'tty',
  'umbrella',
  'upgrade',
  'verified',
  'video_settings',
  'view_sidebar',
  'wash',
  'water_damage',
  'west',
  'wheelchair_pickup',
  'wifi_calling',
  'wifi_protected_setup',
  'wine_bar',
  'wrong_location',
  'wysiwyg',
  'leaderboard',
  '6_ft_apart',
  'book_online',
  'clean_hands',
  'connect_without_contact',
  'coronavirus',
  'elderly',
  'follow_the_signs',
  'leave_bags_at_home',
  'masks',
  'reduce_capacity',
  'sanitizer',
  'send_to_mobile',
  'sick',
  'add_task',
  'contact_page',
  'disabled_by_default',
  'facebook',
  'groups',
  'luggage',
  'no_backpack',
  'no_luggage',
  'outbond',
  'published_with_changes',
  'request_page',
  'stacked_line_chart',
  'unpublished',
  'align_horizontal_center',
  'align_horizontal_left',
  'align_horizontal_right',
  'align_vertical_bottom',
  'align_vertical_center',
  'align_vertical_top',
  'horizontal_distribute',
  'qr_code_2',
  'update_disabled',
  'vertical_distribute',
  'linkedin_square',
  'twitter',
  'male',
  'female',
  'darkmode',
  'account_circle',
  'chat_paste_go_outline',
  'contact_support_outline',
  'quiz_outline',
  'school_outline',
  'magic_button_outline',
  'change_circle_outline',
  'code',
  'heading',
  'near_the_elevator',
  'vertical_align_items_center',
  'horizontal_align_items_center',
  'medal',
  'move_element',
  'not_mobile',
  'social_apple',
  'zoox_edit',
  'zoox_graph',
  'lowest_level',
  'highest_level',
  'far_from_elevator',
  'zoox_backoffice',
  'airbytelogo',
  'edit_outline',
  'drag_arrow',
  'handshake_filled',
  'handshake_outline',
  'social_facebook',
  'social_google',
  'social_instagram',
  'filters_horizontal',
  'format_shapes',
  'replay_5',
  'replay_30',
  'replay_10',
  'replay',
  'file_copy',
  'forward_30',
  'forward_5',
  'forward_10',
  'flash_auto',
  'fiber_pin',
  'fiber_new',
  'edit_location_alt',
  'edit_location',
  'public',
  'signal_wifi_bad',
  'privacy_tip',
  'hdr_on',
  'hdr_strong',
  'eye_cancel',
  'edit_location_alt1',
  'edit_location1',
  'public1',
  'download',
  'upload',
  'domain_disabled',
  'domain',
  'do_disturb_off',
  'disc_full',
  'directions_car',
  'directions_bus',
  'directions_boat',
  'directions_bike',
  'dialer_sip',
  'bluetooth_searching',
  'bluetooth_connected',
  'bluetooth',
  'assignment_late',
  '3d_rotation',
  'arroba',
  '4k_rounded',
  'rounded',
  'ac_unit_rounded',
  'access_alarm_rounded',
  'access_time_rounded',
  'accessibility_new_rounded',
  'accessible_rounded',
  'accessible_forward_rounded',
  'account_balance_rounded',
  'account_balance_wallet_rounded',
  'account_box_rounded',
  'account_circle_rounded',
  'add_rounded',
  'add_a_photo_rounded',
  'add_alarm_rounded',
  'add_box_rounded',
  'add_call_rounded',
  'add_circle_rounded',
  'add_circle_outline_rounded',
  'add_comment_rounded',
  'add_location_rounded',
  'add_photo_alternate_rounded',
  'add_shopping_cart_rounded',
  'add_to_home_screen_rounded',
  'add_to_photos_rounded',
  'add_to_queue_rounded',
  'adjust_rounded',
  'airline_seat_flat_rounded',
  'airline_seat_flat_angled_rounded',
  'airline_seat_individual_suite_rounded',
  'airline_seat_legroom_extra_rounded',
  'airline_seat_legroom_normal_rounded',
  'airline_seat_legroom_reduced_rounded',
  'airline_seat_recline_extra_rounded',
  'airline_seat_recline_normal_rounded',
  'airplanemode_active_rounded',
  'airplanemode_inactive_rounded',
  'airplay_rounded',
  'airport_shuttle_rounded',
  'alarm_rounded',
  'alarm_add_rounded',
  'alarm_off_rounded',
  'alarm_on_rounded',
  'album_rounded',
  'alert',
  'all_inbox_rounded',
  'all_inclusive_rounded',
  'all_out_rounded',
  'ambulance_helicopter',
  'anchor',
  'android_rounded',
  'announcement_rounded',
  'apple',
  'apps_rounded',
  'archive_rounded',
  'arrow_down',
  'arrow_back_rounded',
  'arrow_back_ios_rounded',
  'arrow_downward_rounded',
  'arrow_drop_down_rounded',
  'arrow_drop_down_circle_rounded',
  'arrow_drop_up_rounded',
  'arrow_forward_rounded',
  'arrow_forward_ios_rounded',
  'arrow_left_rounded',
  'arrow_right_rounded',
  'arrow_right_alt_rounded',
  'arrow_upward_rounded',
  'art_track_rounded',
  'aspect_ratio_rounded',
  'assessment_rounded',
  'assignment_rounded',
  'assignment_ind_rounded',
  'assignment_return_rounded',
  'assignment_returned_rounded',
  'assignment_turned_in_rounded',
  'assistant_rounded',
  'assistant_photo_rounded',
  'atm_rounded',
  'attach_file_rounded',
  'attach_money_rounded',
  'attachment_rounded',
  'attribution_rounded',
  'audiotrack_rounded',
  'autorenew_rounded',
  'backspace_rounded',
  'backup_rounded',
  'backward',
  'ballot_rounded',
  'ballpen',
  'baloon',
  'bar_chart_rounded',
  'basketball',
  'battery_charging',
  'battery_alert_rounded',
  'battery_charging_full_rounded',
  'battery_full_rounded',
  'battery_std_rounded',
  'battery_unknown_rounded',
  'beach_access_rounded',
  'bed',
  'beenhere_rounded',
  'bike',
  'block_rounded',
  'bluetooth_disabled_rounded',
  'blur_circular_rounded',
  'blur_linear_rounded',
  'blur_off_rounded',
  'blur_on_rounded',
  'bold',
  'book_rounded',
  'bookmark_rounded',
  'bookmark',
  'bookmarks_rounded',
  'border_all_rounded',
  'border_bottom_rounded',
  'border_clear_rounded',
  'border_color_rounded',
  'border_horizontal_rounded',
  'border_inner_rounded',
  'border_left_rounded',
  'border_outer_rounded',
  'border_right_rounded',
  'border_style_rounded',
  'border_top_rounded',
  'border_vertical_rounded',
  'box',
  'bpm_monitor',
  'branding_watermark_rounded',
  'brightness_full',
  'brightness_1_rounded',
  'brightness_2_rounded',
  'brightness_3_rounded',
  'brightness_4_rounded',
  'brightness_5_rounded',
  'brightness_6_rounded',
  'brightness_7_rounded',
  'brightness_auto_rounded',
  'brightness_high_rounded',
  'brightness_low_rounded',
  'brightness_medium_rounded',
  'broken_image_rounded',
  'brush_rounded',
  'bubble_chart_rounded',
  'bug_report_rounded',
  'bug',
  'build_rounded',
  'bullet_points_dots',
  'burst_mode_rounded',
  'business_rounded',
  'business_center_rounded',
  'cached_rounded',
  'cake_rounded',
  'calendar_event',
  'calendar_today_rounded',
  'calendar_view_day_rounded',
  'calendar',
  'call_rounded',
  'call_end_rounded',
  'call_made_rounded',
  'call_merge_rounded',
  'call_missed_rounded',
  'call_missed_outgoing_rounded',
  'call_received_rounded',
  'call_split_rounded',
  'call_to_action_rounded',
  'camera_rounded',
  'camera_alt_rounded',
  'camera_enhance_rounded',
  'camera_front_rounded',
  'camera_rear_rounded',
  'camera_roll_rounded',
  'camera_1',
  'camera',
  'camp_fire',
  'cancel_rounded',
  'cancel_presentation_rounded',
  'car',
  'card_giftcard_rounded',
  'card_membership_rounded',
  'card_travel_rounded',
  'casino_rounded',
  'cast_rounded',
  'cast_connected_rounded',
  'cast_for_education_rounded',
  'category_rounded',
  'cell_wifi_rounded',
  'center_focus_strong_rounded',
  'center_focus_weak_rounded',
  'central_align',
  'change_history_rounded',
  'chat_rounded',
  'chat_bubble_rounded',
  'chat_bubble_outline_rounded',
  'check_in_a_circle',
  'check_rounded',
  'check_box_rounded',
  'check_box_outline_blank_rounded',
  'check_circle_rounded',
  'check_circle_outline_rounded',
  'chevron_left_rounded',
  'chevron_right_rounded',
  'child_care_rounded',
  'child_friendly_rounded',
  'christmas_socks',
  'chrome_reader_mode_rounded',
  'class_rounded',
  'clear_rounded',
  'clear_all_rounded',
  'clock',
  'close_rounded',
  'closed_caption_rounded',
  'cloud_rounded',
  'cloud_circle_rounded',
  'cloud_done_rounded',
  'cloud_download_rounded',
  'cloud_off_rounded',
  'cloud_queue_rounded',
  'cloud_upload_rounded',
  'code_rounded',
  'coffee',
  'collections_rounded',
  'collections_bookmark_rounded',
  'color_palette',
  'colorize_rounded',
  'comment_rounded',
  'commute_rounded',
  'compare_rounded',
  'compare_arrows_rounded',
  'compass_calibration_rounded',
  'compass',
  'computer_rounded',
  'cone_icecream',
  'confirmation_number_rounded',
  'contact_mail_rounded',
  'contact_phone_rounded',
  'contact_support_rounded',
  'contacts_rounded',
  'control_camera_rounded',
  'control_point_rounded',
  'control_point_duplicate_rounded',
  'copy_rounded',
  'copyright_rounded',
  'create_rounded',
  'create_new_folder_rounded',
  'credit_card',
  'credit_card_rounded',
  'crop_3_2_rounded',
  'crop_5_4_rounded',
  'crop_7_5_rounded',
  'crop_16_9_rounded',
  'crop_rounded',
  'crop_din_rounded',
  'crop_free_rounded',
  'crop_landscape_rounded',
  'crop_original_rounded',
  'crop_portrait_rounded',
  'crop_rotate_rounded',
  'crop_square_rounded',
  'cupcake',
  'cut_rounded',
  'dashboard_rounded',
  'data_usage_rounded',
  'date_range_rounded',
  'dehaze_rounded',
  'delete_rounded',
  'delete_forever_rounded',
  'delete_outline_rounded',
  'delete_sweep_rounded',
  'delete',
  'departure_board_rounded',
  'description_rounded',
  'desktop_access_disabled_rounded',
  'desktop_mac_rounded',
  'desktop_windows_rounded',
  'details_rounded',
  'developer_board_rounded',
  'developer_mode_rounded',
  'device_hub_rounded',
  'device_unknown_rounded',
  'devices_rounded',
  'devices_other_rounded',
  'dialpad_rounded',
  'diamond',
  'directions_rounded',
  'directions_railway_rounded',
  'directions_run_rounded',
  'directions_subway_rounded',
  'directions_transit_rounded',
  'directions_walk_rounded',
  'diving_mask',
  'dns_rounded',
  'do_disturb_rounded',
  'do_disturb_alt_rounded',
  'do_disturb_on_rounded',
  'dock_rounded',
  'document',
  'dollar',
  'done_rounded',
  'done_all_rounded',
  'done_outline_rounded',
  'donut_large_rounded',
  'donut_small_rounded',
  'double_check',
  'double_note',
  'download_rounded',
  'download_done_rounded',
  'drafts_rounded',
  'drag_handle_rounded',
  'drag_indicator_rounded',
  'duo_rounded',
  'dvr_rounded',
  'edit_rounded',
  'edit_attributes_rounded',
  'egg',
  'eject_rounded',
  'email_rounded',
  'emoticon_baby',
  'emoticon_devil',
  'emoticon_sad',
  'emoticon',
  'enhanced_encryption_rounded',
  'equalizer_rounded',
  'error_rounded',
  'error_outline_rounded',
  'euro_symbol_rounded',
  'ev_charging',
  'ev_station_rounded',
  'event_rounded',
  'event_available_rounded',
  'event_busy_rounded',
  'event_note_rounded',
  'event_seat_rounded',
  'exit_to_app_rounded',
  'expand_less_rounded',
  'expand_more_rounded',
  'explicit_rounded',
  'explore_rounded',
  'explore_off_rounded',
  'exposure_rounded',
  'exposure_neg_1_rounded',
  'exposure_neg_2_rounded',
  'exposure_plus_1_rounded',
  'exposure_plus_2_rounded',
  'exposure_zero_rounded',
  'extension_rounded',
  'eye_minus',
  'eye_open',
  'face_id',
  'face_rounded',
  'face_unlock_rounded',
  'fast_food',
  'fast_forward_rounded',
  'fast_rewind_rounded',
  'fastfood_rounded',
  'favorite_rounded',
  'favorite_border_rounded',
  'featured_play_list_rounded',
  'featured_video_rounded',
  'feedback_rounded',
  'fiber_dvr_rounded',
  'fiber_manual_record_rounded',
  'fiber_smart_record_rounded',
  'file_copy_rounded',
  'filter_1_rounded',
  'filter_2_rounded',
  'filter_3_rounded',
  'filter_4_rounded',
  'filter_5_rounded',
  'filter_6_rounded',
  'filter_7_rounded',
  'filter_8_rounded',
  'filter_9_rounded',
  'filter_9_plus_rounded',
  'filter_rounded',
  'filter_b_and_w_rounded',
  'filter_center_focus_rounded',
  'filter_drama_rounded',
  'filter_frames_rounded',
  'filter_hdr_rounded',
  'filter_list_rounded',
  'filter_none_rounded',
  'filter_tilt_shift_rounded',
  'filter_vintage_rounded',
  'filters_vertical',
  'find_in_page_rounded',
  'find_replace_rounded',
  'fingerprint_rounded',
  'first_page_rounded',
  'fitness_center_rounded',
  'flag_rounded',
  'flare_rounded',
  'flash_off_rounded',
  'flash_on_rounded',
  'flight_rounded',
  'flight_land_rounded',
  'flight_takeoff_rounded',
  'flip_rounded',
  'flip_to_back_rounded',
  'flip_to_front_rounded',
  'folder_rounded',
  'folder_open_rounded',
  'folder_shared_rounded',
  'folder_special_rounded',
  'font_download_rounded',
  'football',
  'format_align_center_rounded',
  'format_align_justify_rounded',
  'format_align_left_rounded',
  'format_align_right_rounded',
  'format_bold_rounded',
  'format_clear_rounded',
  'format_color_fill_rounded',
  'format_color_reset_rounded',
  'format_color_text_rounded',
  'format_indent_decrease_rounded',
  'format_indent_increase_rounded',
  'format_line_spacing_rounded',
  'format_list_bulleted_rounded',
  'format_list_numbered_rounded',
  'format_list_numbered_rtl_rounded',
  'format_paint_rounded',
  'format_quote_rounded',
  'format_size_rounded',
  'format_strikethrough_rounded',
  'format_textdirection_l_to_r_rounded',
  'format_textdirection_r_to_l_rounded',
  'format_underlined_rounded',
  'forum_rounded',
  'forward_5_rounded',
  'forward_rounded',
  'forward_30_rounded',
  'forward',
  'free_breakfast_rounded',
  'full_arrow_down',
  'full_arrow_left',
  'full_arrow_right',
  'full_arrow_up',
  'fullscreen_rounded',
  'fullscreen_exit_rounded',
  'functions_rounded',
  'g_translate_rounded',
  'gamepad_rounded',
  'games_rounded',
  'gavel_rounded',
  'gesture_rounded',
  'get_app_rounded',
  'gif_rounded',
  'gift',
  'golf_course_rounded',
  'gps_fixed_rounded',
  'gps_not_fixed_rounded',
  'gps_off_rounded',
  'grade_rounded',
  'gradient_rounded',
  'grain_rounded',
  'grid_round',
  'grid_sharp',
  'grid_off_rounded',
  'grid_on_rounded',
  'group_rounded',
  'group_add_rounded',
  'hamburger_menu',
  'hand_pointer',
  'hd_rounded',
  'hdr_off_rounded',
  'hdr_weak_rounded',
  'headset_rounded',
  'headset_mic_rounded',
  'healing_rounded',
  'health',
  'hearing_rounded',
  'heart_tablet',
  'heart',
  'help_rounded',
  'help_outline_rounded',
  'high_quality_rounded',
  'highlight_rounded',
  'highlight_off_rounded',
  'history_rounded',
  'home_rounded',
  'home',
  'horizontal_split_rounded',
  'hot_tub_rounded',
  'hotel_rounded',
  'hourglass_empty_rounded',
  'hourglass_full_rounded',
  'how_to_reg_rounded',
  'how_to_vote_rounded',
  'http_rounded',
  'https_rounded',
  'ice_skates',
  'image_rounded',
  'image_aspect_ratio_rounded',
  'image_search_rounded',
  'import_contacts_rounded',
  'import_export_rounded',
  'important_devices_rounded',
  'inbox_rounded',
  'inbox',
  'indeterminate_check_box_rounded',
  'info_question_mark',
  'info_rounded',
  'info_outline_rounded',
  'input_rounded',
  'insert_chart_rounded',
  'insert_chart_outlined_rounded',
  'insert_comment_rounded',
  'insert_drive_file_rounded',
  'insert_emoticon_rounded',
  'insert_invitation_rounded',
  'insert_link_rounded',
  'insert_photo_rounded',
  'invert_colors_rounded',
  'invert_colors_off_rounded',
  'iso_rounded',
  'keyboard_rounded',
  'keyboard_arrow_down_rounded',
  'keyboard_arrow_left_rounded',
  'keyboard_arrow_right_rounded',
  'keyboard_arrow_up_rounded',
  'keyboard_backspace_rounded',
  'keyboard_capslock_rounded',
  'keyboard_hide_rounded',
  'keyboard_return_rounded',
  'keyboard_tab_rounded',
  'keyboard_voice_rounded',
  'kitchen_rounded',
  'label_rounded',
  'label_important_rounded',
  'label_important_outline_rounded',
  'label_off_rounded',
  'label_outline_rounded',
  'landscape_rounded',
  'language_rounded',
  'laptop_rounded',
  'laptop_chromebook_rounded',
  'laptop_mac_rounded',
  'laptop_windows_rounded',
  'last_page_rounded',
  'launch_rounded',
  'layers_rounded',
  'layers_clear_rounded',
  'layers',
  'leak_add_rounded',
  'leak_remove_rounded',
  'left_align',
  'library_add_rounded',
  'library_books_rounded',
  'library_music24px_rounded',
  'lightbulb_outline_rounded',
  'line_style_rounded',
  'line_weight_rounded',
  'linear_scale_rounded',
  'link_rounded',
  'link_off_rounded',
  'link',
  'linked_camera_rounded',
  'list_rounded',
  'list_alt_rounded',
  'live_help_rounded',
  'live_tv_rounded',
  'local_activity_rounded',
  'local_airport_rounded',
  'local_atm_rounded',
  'local_bar_rounded',
  'local_cafe_rounded',
  'local_car_wash_rounded',
  'local_convenience_store_rounded',
  'local_dining_rounded',
  'local_drink_rounded',
  'local_florist_rounded',
  'local_gas_station_rounded',
  'local_grocery_store_rounded',
  'local_hospital_rounded',
  'local_hotel_rounded',
  'local_laundry_service_rounded',
  'local_library_rounded',
  'local_mall_rounded',
  'local_movies_rounded',
  'local_offer_rounded',
  'local_parking_rounded',
  'local_pharmacy_rounded',
  'local_phone_rounded',
  'local_pizza_rounded',
  'local_play_rounded',
  'local_post_office_rounded',
  'local_printshop_rounded',
  'local_see_rounded',
  'local_shipping_rounded',
  'local_taxi_rounded',
  'location_city_rounded',
  'location_disabled_rounded',
  'location_off_rounded',
  'location_on_rounded',
  'location_searching_rounded',
  'lock_rounded',
  'lock_open_rounded',
  'lock_outline_rounded',
  'lock',
  'looks_3_rounded',
  'looks_4_rounded',
  'looks_5_rounded',
  'looks_6_rounded',
  'looks_rounded',
  'looks_one_rounded',
  'looks_two_rounded',
  'loop_rounded',
  'loupe_rounded',
  'low_priority_rounded',
  'loyalty_rounded',
  'mail_rounded',
  'mail_outline_rounded',
  'map_rounded',
  'markunread_rounded',
  'markunread_mailbox_rounded',
  'maximize_rounded',
  'meeting_room_rounded',
  'memory_rounded',
  'menu_rounded',
  'merge_type_rounded',
  'message_left',
  'message_rounded',
  'metro',
  'mic_rounded',
  'mic_none_rounded',
  'mic_off_rounded',
  'microphone',
  'minimize_rounded',
  'missed_video_call_rounded',
  'mms_rounded',
  'mobile_friendly_rounded',
  'mobile_off_rounded',
  'mobile_screen_share_rounded',
  'mode_rounded',
  'mode_comment_rounded',
  'monetization_on_rounded',
  'money_rounded',
  'money_off_rounded',
  'money_off_csred_rounded',
  'monochrome_photos_rounded',
  'mood_rounded',
  'mood_bad_rounded',
  'more_rounded',
  'more_horiz_rounded',
  'more_vert_rounded',
  'motorcycle_rounded',
  'mouse_rounded',
  'move_to_inbox_rounded',
  'movie_rounded',
  'movie_creation_rounded',
  'movie_filter_rounded',
  'multiline_chart_rounded',
  'music_playlist',
  'music_note_rounded',
  'music_off_rounded',
  'music_video_rounded',
  'my_location_rounded',
  'nature_rounded',
  'nature_people_rounded',
  'navigate_before_rounded',
  'navigate_next_rounded',
  'navigation_rounded',
  'near_me_rounded',
  'network_cell_rounded',
  'network_check_rounded',
  'network_locked_rounded',
  'network_wifi_rounded',
  'new_releases_rounded',
  'next_week_rounded',
  'nfc_rounded',
  'no_smoking',
  'no_encryption_rounded',
  'no_encryption_gmailerrorred_rounded',
  'no_meeting_room_rounded',
  'no_sim_rounded',
  'not_interested_rounded',
  'not_listed_location_rounded',
  'note_rounded',
  'note_add_rounded',
  'notepad',
  'notes_rounded',
  'notification_important_rounded',
  'notifications_rounded',
  'notifications_active_rounded',
  'notifications_none_rounded',
  'notifications_off_rounded',
  'notifications_paused_rounded',
  'offline_bolt_rounded',
  'offline_pin_rounded',
  'ondemand_video_rounded',
  'opacity_rounded',
  'open_folder',
  'open_in_browser_rounded',
  'open_in_new_rounded',
  'open_with_rounded',
  'outlined_flag_rounded',
  'pages_rounded',
  'pageview_rounded',
  'palette_rounded',
  'pan_tool_rounded',
  'panorama_rounded',
  'panorama_fish_eye_rounded',
  'panorama_horizontal_rounded',
  'panorama_vertical_rounded',
  'panorama_wide_angle_rounded',
  'paragraph',
  'party_mode_rounded',
  'paste_rounded',
  'pause_rounded',
  'pause_circle_filled_rounded',
  'pause_circle_outline_rounded',
  'pause_presentation_rounded',
  'payment_rounded',
  'pen_1',
  'pen',
  'people_rounded',
  'people_outline_rounded',
  'perm_camera_mic_rounded',
  'perm_contact_calendar_rounded',
  'perm_data_setting_rounded',
  'perm_device_information_rounded',
  'perm_identity_rounded',
  'perm_media_rounded',
  'perm_phone_msg_rounded',
  'perm_scan_wifi_rounded',
  'person_rounded',
  'person_add_rounded',
  'person_add_disabled_rounded',
  'person_outline_rounded',
  'person_pin_rounded',
  'person_pin_circle_rounded',
  'personal_video_rounded',
  'pets_rounded',
  'phone_call_01',
  'phone_call_02',
  'phone_notch',
  'phone_rounded',
  'phone_android_rounded',
  'phone_bluetooth_speaker_rounded',
  'phone_callback_rounded',
  'phone_forwarded_rounded',
  'phone_in_talk_rounded',
  'phone_iphone_rounded',
  'phone_locked_rounded',
  'phone_missed_rounded',
  'phone_paused_rounded',
  'phonelink_rounded',
  'phonelink_erase_rounded',
  'phonelink_lock_rounded',
  'phonelink_off_rounded',
  'phonelink_ring_rounded',
  'phonelink_setup_rounded',
  'photo_rounded',
  'photo_album_rounded',
  'photo_camera_rounded',
  'photo_filter_rounded',
  'photo_library_rounded',
  'photo_size_select_actual_rounded',
  'photo_size_select_large_rounded',
  'photo_size_select_small_rounded',
  'picture_as_pdf_rounded',
  'picture_in_picture_rounded',
  'picture_in_picture_alt_rounded',
  'pie_chart_rounded',
  'pie_chart_outline_rounded',
  'pin_drop_rounded',
  'pin',
  'place_rounded',
  'plane',
  'play_arrow_rounded',
  'play_circle_filled_rounded',
  'play_circle_filled_white_rounded',
  'play_circle_outline_rounded',
  'play_for_work_rounded',
  'playlist_add_rounded',
  'playlist_add_check_rounded',
  'playlist_play_rounded',
  'plus_one_rounded',
  'poll_rounded',
  'polymer_rounded',
  'pool_rounded',
  'portable_wifi_off_rounded',
  'portrait_rounded',
  'potion',
  'power_rounded',
  'power_input_rounded',
  'power_off_rounded',
  'power_settings_new_rounded',
  'power',
  'pregnant_woman_rounded',
  'present_to_all_rounded',
  'print_rounded',
  'print_disabled_rounded',
  'print',
  'priority_high_rounded',
  'publish_rounded',
  'query_builder_rounded',
  'question_answer_rounded',
  'queue_rounded',
  'queue_music_rounded',
  'queue_play_next_rounded',
  'radio_rounded',
  'radio_button_checked_rounded',
  'radio_button_unchecked_rounded',
  'rain',
  'rambo_knife',
  'rate_review_rounded',
  'receipt_rounded',
  'recent_actors_rounded',
  'record_voice_over_rounded',
  'redeem_rounded',
  'redo_rounded',
  'refresh_rounded',
  'remove_rounded',
  'remove_circle_rounded',
  'remove_circle_outline_rounded',
  'remove_from_queue_rounded',
  'remove_red_eye_rounded',
  'remove_shopping_cart_rounded',
  'reorder_rounded',
  'repeat_rounded',
  'repeat_one_rounded',
  'reply_rounded',
  'reply_all_rounded',
  'report_rounded',
  'report_gmailerrorred_rounded',
  'report_off_rounded',
  'report_problem_rounded',
  'restaurant_rounded',
  'restaurant_menu_rounded',
  'restaurant',
  'restore_rounded',
  'restore_from_trash_rounded',
  'restore_page_rounded',
  'right_align',
  'ring_volume_rounded',
  'room_rounded',
  'room_service_rounded',
  'rotate_90_degrees_ccw_rounded',
  'rotate_left_rounded',
  'rotate_right_rounded',
  'rounded_corner_rounded',
  'router_rounded',
  'rowing_rounded',
  'rss_feed_rounded',
  'rv_hookup_rounded',
  'satellite_rounded',
  'save_rounded',
  'save_alt_rounded',
  'scanner_rounded',
  'scatter_plot_rounded',
  'schedule_rounded',
  'school_rounded',
  'scissors',
  'score_rounded',
  'screen_lock_landscape_rounded',
  'screen_lock_portrait_rounded',
  'screen_lock_rotation_rounded',
  'screen_rotation_rounded',
  'screen_share_rounded',
  'screen',
  'sd_card_rounded',
  'sd_card_alert_rounded',
  'sd_storage_rounded',
  'search_rounded',
  'security_rounded',
  'select_all_rounded',
  'send_to',
  'send_rounded',
  'send',
  'sentiment_dissatisfied_rounded',
  'sentiment_neutral_rounded',
  'sentiment_satisfied_rounded',
  'sentiment_satisfied_alt_rounded',
  'sentiment_very_dissatisfied_rounded',
  'sentiment_very_satisfied_rounded',
  'settings_rounded',
  'settings_applications_rounded',
  'settings_backup_restore_rounded',
  'settings_bluetooth_rounded',
  'settings_brightness_rounded',
  'settings_cell_rounded',
  'settings_ethernet_rounded',
  'settings_input_antenna_rounded',
  'settings_input_component_rounded',
  'settings_input_composite_rounded',
  'settings_input_hdmi_rounded',
  'settings_input_svideo_rounded',
  'settings_overscan_rounded',
  'settings_phone_rounded',
  'settings_power_rounded',
  'settings_remote_rounded',
  'settings_system_daydream_rounded',
  'settings_voice_rounded',
  'settings',
  'share_rounded',
  'shell',
  'shield',
  'shop_rounded',
  'shop_two_rounded',
  'shopping_cart',
  'shopping_basket_rounded',
  'shopping_cart_rounded',
  'short_text_rounded',
  'show_chart_rounded',
  'shuffle_rounded',
  'shutter_speed_rounded',
  'shutter',
  'signal_cellular_alt_rounded',
  'signal_cellular_connected_no_internet_4_bar_rounded',
  'signal_cellular_no_sim_rounded',
  'signal_cellular_null_rounded',
  'signal_cellular_off_rounded',
  'signal_wifi_off_rounded',
  'signal_wifi_statusbar_connected_no_internet_26x24px_rounded',
  'signal_wifi_statusbar_not_connected_26x24px_rounded',
  'signal_wifi_statusbar_null_26x24px_rounded',
  'sim_card_rounded',
  'skip_next_rounded',
  'skip_previous_rounded',
  'slideshow_rounded',
  'slow_motion_video_rounded',
  'smartphone_rounded',
  'smoke_free_rounded',
  'smoking_rooms_rounded',
  'sms_rounded',
  'sms_failed_rounded',
  'snooze_rounded',
  'snow',
  'snowflake',
  'sort_rounded',
  'sort_by_alpha_rounded',
  'spa_rounded',
  'space_bar_rounded',
  'speaker_rounded',
  'speaker_group_rounded',
  'speaker_notes_rounded',
  'speaker_notes_off_rounded',
  'speaker_phone_rounded',
  'spellcheck_rounded',
  'star_rounded',
  'star_border_rounded',
  'star_border_purple500_rounded',
  'star_half_rounded',
  'star_outline_rounded',
  'star_purple500_rounded',
  'star_rate_18px_rounded',
  'star',
  'stars_rounded',
  'stay_current_landscape_rounded',
  'stay_current_portrait_rounded',
  'stay_primary_landscape_rounded',
  'stay_primary_portrait_rounded',
  'stethoscope',
  'stop_rounded',
  'stop_screen_share_rounded',
  'storage_rounded',
  'store_rounded',
  'store_mall_directory_rounded',
  'straighten_rounded',
  'streetview_rounded',
  'strikethrough_s_rounded',
  'style_rounded',
  'subdirectory_arrow_left_rounded',
  'subdirectory_arrow_right_rounded',
  'subject_rounded',
  'subscriptions_rounded',
  'subtitles_rounded',
  'subway_rounded',
  'sun',
  'supervised_user_circle_rounded',
  'supervisor_account_rounded',
  'surround_sound_rounded',
  'swap_calls_rounded',
  'swap_horiz_rounded',
  'swap_horizontal_circle_rounded',
  'swap_vert_rounded',
  'swap_vertical_circle_rounded',
  'switch_camera_rounded',
  'switch_video_rounded',
  'sync_rounded',
  'sync_disabled_rounded',
  'sync_problem_rounded',
  'system_update_rounded',
  'system_vertical_alt_rounded',
  'tab_rounded',
  'tab_unselected_rounded',
  'table_lamp',
  'table_chart_rounded',
  'table',
  'tablet_horizontal',
  'tablet_rounded',
  'tablet_android_rounded',
  'tablet_mac_rounded',
  'tag_faces_rounded',
  'tap_and_play_rounded',
  'tent',
  'terrain_rounded',
  'text_fields_rounded',
  'text_format_rounded',
  'text_rotate_up_rounded',
  'text_rotate_vertical_rounded',
  'text_rotation_angle_down_rounded',
  'text_rotation_angle_up_rounded',
  'text_rotation_down_rounded',
  'text_rotation_none_rounded',
  'textsms_rounded',
  'texture_rounded',
  'theaters_rounded',
  'theatre',
  'thermostat_rounded',
  'thumb_down_rounded',
  'thumb_down_alt_rounded',
  'thumb_up_rounded',
  'thumb_up_alt_rounded',
  'thumbs_up_down_rounded',
  'ticket',
  'time_to_leave_rounded',
  'timelapse_rounded',
  'timeline_rounded',
  'timer_3_rounded',
  'timer_10_rounded',
  'timer_rounded',
  'timer_off_rounded',
  'title_rounded',
  'toc_rounded',
  'today_rounded',
  'toggle_off',
  'toggle_on',
  'toggle_off_rounded',
  'toggle_on_rounded',
  'toll_rounded',
  'tonality_rounded',
  'touch_app_rounded',
  'toys_rounded',
  'track_changes_rounded',
  'train_rounded',
  'tram_rounded',
  'transfer_within_a_station_rounded',
  'transform_rounded',
  'transit_enterexit_rounded',
  'translate_rounded',
  'trending_down_rounded',
  'trending_flat_rounded',
  'trending_up_rounded',
  'trip_origin_rounded',
  'truck',
  'trumpet',
  'tune_rounded',
  'turned_in_rounded',
  'turned_in_not_rounded',
  'tv_rounded',
  'tv_off_rounded',
  'unarchive_rounded',
  'undo_rounded',
  'unfold_less_rounded',
  'unfold_more_rounded',
  'unsubscribe_rounded',
  'update_rounded',
  'upload_rounded',
  'usb_rounded',
  'vector_curve',
  'verified_user_rounded',
  'vertical_align_bottom_rounded',
  'vertical_align_center_rounded',
  'vertical_align_top_rounded',
  'vertical_split_rounded',
  'vibration_rounded',
  'video_call_rounded',
  'video_label_rounded',
  'video_library_rounded',
  'videocam_rounded',
  'videocam_off_rounded',
  'videogame_asset_rounded',
  'view_agenda_rounded',
  'view_array_rounded',
  'view_carousel_rounded',
  'view_column_rounded',
  'view_comfy_rounded',
  'view_compact_rounded',
  'view_day_rounded',
  'view_headline_rounded',
  'view_list_rounded',
  'view_module_rounded',
  'view_quilt_rounded',
  'view_stream_rounded',
  'view_week_rounded',
  'vignette_rounded',
  'voice_chat_rounded',
  'voice_over_off_rounded',
  'voicemail_rounded',
  'volume_down_rounded',
  'volume_mute_rounded',
  'volume_off_rounded',
  'volume_up_rounded',
  'vpn_key_rounded',
  'vpn_lock_rounded',
  'wallpaper_rounded',
  'warning_rounded',
  'warning_amber_rounded',
  'watch_rounded',
  'watch_later_rounded',
  'watch',
  'waves_rounded',
  'wb_auto_rounded',
  'wb_cloudy_rounded',
  'wb_incandescent_rounded',
  'wb_iridescent_rounded',
  'wb_sunny_rounded',
  'wc_rounded',
  'web_rounded',
  'web_asset_rounded',
  'weekend_rounded',
  'whatshot_rounded',
  'where_to_vote_rounded',
  'widgets_rounded',
  'wifi_rounded',
  'wifi_lock_rounded',
  'wifi_off_rounded',
  'wifi_tethering_rounded',
  'work_rounded',
  'work_off_rounded',
  'work_outline_rounded',
  'wrap_text_rounded',
  'x_in_a_circle',
  'youtube_searched_for_rounded',
  'zoom_in_rounded',
  'zoom_out_rounded',
  'zoom_out_map_rounded',
  'zoox_ai',
  'zoox_alert',
  'zoox_briefcase',
  'zoox_central',
  'zoox_competitor',
  'zoox_creditcard',
  'zoox_fingerprint',
  'zoox_gear',
  'zoox_heart',
  'zoox_heartmsg',
  'zoox_info',
  'zoox_key',
  'zoox_lgpd',
  'zoox_menu',
  'zoox_phonemsg',
  'zoox_pin',
  'zoox_rights',
  'zoox_share',
  'zoox_store',
  'zoox_user',
  'zoox_usergroup',
  'zoox_weblist',
  'zoox_config',
  'zoox_document_edit',
  'zoox_document',
  'zoox_building',
  'zoox_globe',
  'zoox_home',
  'zoox_megaphone',
  'zoox_person',
  'zoox_analytics',
  'zoox_report',
  'zoox_jorney',
  'zoox_dashboard',
  'zoox_contentcreation',
  'zoox_audiences',
]
